__turbopack_context__.v({
  "btnClose": "index-module__3oMi2q__btnClose",
  "btnsWrapper": "index-module__3oMi2q__btnsWrapper",
  "firstP": "index-module__3oMi2q__firstP",
  "img": "index-module__3oMi2q__img",
  "modal": "index-module__3oMi2q__modal",
  "qr": "index-module__3oMi2q__qr",
  "qrWrapper": "index-module__3oMi2q__qrWrapper",
  "secondP": "index-module__3oMi2q__secondP",
  "textWrapper": "index-module__3oMi2q__textWrapper",
  "wrapper": "index-module__3oMi2q__wrapper",
});
